export const APP_REGION = process.env.REACT_APP_AWS_REGION; //AWS APP REGION
export const POOL_ID = process.env.REACT_APP_COGNITO_POOL_ID; // AWS COGNITO POOL ID
export const CLINET_ID = process.env.REACT_APP_COGNITO_CLIENT_ID; // AWS COGNITO CLIENT ID
export const APP_ENDPOINT = process.env.REACT_APP_APP_ENDPOINT; // AWS API GW APP ENDPOINT
export const CHAIN_ID_MAP = {
  CHAIN_ID_POLYGON_MAINNET: "Polygon Mainnet",
  CHAIN_ID_POLYGON_MUMBAI: "Polygon Mumbai",
};
